import React from "react";

const NumberField = ({
  value,
  onChange,
  min,
  max,
  step,
  placeholder,
  required,
  unit,
}) => {
  return (
    <div className="number-field-container">
      <input
        type="number"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        min={min}
        max={max}
        step={step || 1}
        placeholder={placeholder || ""}
        required={required}
        className="number-field"
      />
      {unit && <span className="number-unit">{unit}</span>}
    </div>
  );
};

export default NumberField;
